// @flow

import { reduce } from 'lodash';

import { Screen } from '@zapier/theme';

type Queryables = {
  width: number,
};

type ParsedQuery = {
  'min-width'?: number,
  'max-width'?: number,
};

export const parseQuery = (query: string): ParsedQuery => {
  // Only works for `and` queries for now.
  const parts = query
    .split('and')
    .map(part => part.trim())
    // Remove parentheses
    .map(part => part.replace(/[()]/g, ''));
  return parts.reduce((accum, part) => {
    const [key = '', val = ''] = part.split(':');
    accum[key.trim()] = parseInt(val, 10);
    return accum;
  }, {});
};

const doesQueryMatch = (queryables: Queryables, query: ParsedQuery) => {
  return [
    queryables.width >= (query['min-width'] || 0),
    queryables.width <= (query['max-width'] || Infinity),
  ].every(Boolean);
};

type Queries = Array<string>;
type Accum = {
  [string]: boolean,
};
export const findMatchingQueries = (
  queryables: Queryables,
  queries: Queries
) => {
  return reduce(
    queries,
    (accum: Accum, queryToCheck) => {
      const mediaQuery = Screen.queries[queryToCheck] || queryToCheck;
      const parsedQuery = parseQuery(mediaQuery);
      accum[queryToCheck] = doesQueryMatch(queryables, parsedQuery);
      return accum;
    },
    {}
  );
};

export default findMatchingQueries;
